module.exports = __webpack_public_path__ + "static/case-eizo-6acd436a76c0cd92ec15943d855bdbec.mp4";